<template>
  <div class="staff-StaffSelector">
    <template v-if="disabled">
      <span class="text-primary">
        {{ findStaff.map(o => o.teamName).join() }}
      </span>
    </template>
    <div
      v-else
      class="staff-StaffSelector_content"
      @click="handleVisible"
    >
      <!-- 未选中员工 -->
      <span
        v-if="!value"
        class="placeholder"
      >
        <span>{{ placeholder }}</span>

        <feather-icon
          icon="ChevronDownIcon"
          class="placeholder-icon"
          size="20"
        />
      </span>
      <!-- 已选中员工 -->
      <span
        v-else
        class="hasValue"
      >
        <!-- 选择器为多选时，选中人员展示 -->
        <div
          v-if="multiple"
          style="width: calc(100% - 50px);"
        >
          <a-tag
            v-for="(item, i) in findStaff"
            :key="i"
            closable
            class="mt-0-5"
            @close="delCheckedStaff($event, item.id)"
          >
            <!-- {{ item.enName }} -->
            {{ item.teamName }}
          </a-tag>
        </div>
        <!-- 选择器为单选时，选中人员展示 -->
        <span v-else>{{ findStaff.map(o => o.teamName).join() }}</span>
        <feather-icon
          icon="XCircleIcon"
          class="hasValue-icon"
          size="16"
          @click.stop="clearValue"
        />
        <feather-icon
          icon="ChevronDownIcon"
          class="placeholder-icon"
          size="20"
        />
      </span>
    </div>

    <!-- 员工选择器 -->
    <c-modal
      :visible="visible"
      title="Team selector"
      size="lg"
      body-class="staff-selector-modal_body"
      footer-class="staff-selector-modal_footer"
      @close="close"
      @modelConfirm="handleModelConfirm"
      @confirmEnter="hoverConfirm = true"
      @confirmLeave="hoverConfirm = false"
    >
      <template slot="content">
        <div class="selector-content">
          <!-- 分栏Tab的公共显示区域 -->
          <div class="staff-search">
            <b-form-input
              v-model="searchWorker"
              :placeholder="$t('_components.placeholder.input')+ 'Worker Name Or No.'"
              type="text"
            />
            <!-- or number -->
            <b-button
              variant="primary"
              size="sm"
              @click="handleSearchWorker"
            >
              {{ i18n('btns.search') }}
            </b-button>
          </div>
          <!--  -->
          <!-- 工人查询列表 -->
          <div
            class="staff-list my-border staff-list__maxheight"
            style="height: calc(100% - 48px);"
            :class="{'my-border__hover': staffLoaded}"
          >
            <b-overlay
              :show="workerListLoading"
              rounded="sm"
            >
              <div style="width: 100%;height: 100%">
                <template v-for="(item, i) in workerData">
                  <template v-if="multiple">
                    <b-form-checkbox
                      :key="i"
                      v-model="chcekedStaff"
                      class="staff-list__item"
                      :class="{'staff-list__item-checked': !!chcekedStaffResult.find(o => o.id === item.id)}"
                      :value="item.id"
                    >
                      <span style="color: #2979ff;">{{ item.supervisorCode }}</span> {{ item.teamName }}
                    </b-form-checkbox>
                  </template>
                  <div
                    v-else
                    :key="i"
                    class="staff-list__item"
                    :class="{'staff-list__item-checked': chcekedStaff.indexOf(item.id) != -1}"
                    @click="handleStaffClick(item)"
                  >
                    <span style="color: #2979ff;">{{ item.supervisorCode }}</span> {{ item.teamName }}
                  </div>
                </template>
              </div>

            </b-overlay>

          </div>
          <!-- 选中工人列表 -->
          <!-- 将选中的工人左右移动 -->
          <div
            class="checked-staff my-border"
            :class="hoverConfirm ? (chcekedStaffResult.length>0 ? 'my-border__hover' : 'my-border__hover-wrning') : ''"
          >
            <!-- 操作按钮（控制是否选中） -->
            <div class="checked-staff__btns">
              <div
                :class="chcekedStaff.length>0 ? 'not-disabled':'is-disabled'"
                @click="handleMoveRes"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  size="20"
                />
              </div>
              <div
                :class="chcekedResStaff.length>0 ? 'not-disabled':'is-disabled'"
                @click="handleClearRes"
              >
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="20"
                />
              </div>
            </div>
            <!-- 选中数据展示 -->
            <div class="checked-staff__content">
              <template v-for="(item, i) in chcekedStaffResult">
                <b-form-checkbox
                  v-if="multiple"
                  :key="i"
                  v-model="chcekedResStaff"
                  class="staff-list__item"
                  :value="item.id"
                >
                  <span style="color: #2979ff;">{{ item.supervisorCode }}</span> {{ item.teamName }}
                </b-form-checkbox>
                <div
                  v-else
                  :key="i"
                  class="staff-list__item"
                  :class="{'staff-list__item-checked': chcekedResStaff.indexOf(item.id) != -1}"
                  @click="handleResStaffClick(item)"
                >
                  <span style="color: #2979ff;">{{ item.supervisorCode }}</span> {{ item.teamName }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </c-modal>
  </div>
</template>

<script>
import {
  BTab, BTabs, BOverlay, BFormCheckbox, BFormInput, BButton,
} from 'bootstrap-vue'
import WORKER from '@/api/worker/index'
import { mapGetters } from 'vuex';
import { deepClone } from '@/util/util';

export default {
  components: {
    CModal: () => import('@/components/crud/modal.vue'),
    BOverlay,
    BFormCheckbox,
    BFormInput,
    BButton,
  },
  filters: {
    nameFormat(item) {
      return item.map(o => `${o.name}(${o.employmentCode})`).join()
    },
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    /**
     * multiple  是否多选
     * hasSupervisor  是否显示工长  true 不显示
     * isQuickTransition 是否是快速转场流程
     */
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      // 选中员工 相关参数
      chcekedStaff: [],
      chcekedStaffResult: [],
      chcekedResStaff: [],
      checkedStaffData: [],
      // 查询员工参数
      staffData: [],

      teamLoading: false,
      // 班组数据
      teamsTreeData: [],
      checkedTeam: false,

      hoverConfirm: false,
      staffLoaded: false,
      multiple: false,
      workerListLoading: false,

      query: this.option.dictQuery,
      searchWorker: '',
    }
  },
  computed: {
    ...mapGetters(['language', 'recentlyUser']),
    placeholder() {
      return this.option.placeholder ? this.option.placeholder : this.$t('_components.placeholder.input') + this.label
    },
    findStaff() {
      let find = []
      if (this.value) {
        const valArr = this.value.split(',')
        find = this.checkedStaffData.filter(o => (valArr.indexOf(o.id.toString()) !== -1)) || []
        if (find.length <= 0) {
          find = this.staffData.filter(o => (valArr.indexOf(o.id.toString()) !== -1)) || []
        }
      }
      console.log(find, 'find');
      return find
    },
    recentlyStaff() {
      return this.recentlyUser.staff || []
    },
    workerData() {
      return this.staffData
    },
  },
  watch: {
    value(e) {

    },
    'option.multiple': {
      handler(e) {
        this.multiple = e || false
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.value && this.staffData.length <= 0) {
      this.workerListLoading = true
      const query = deepClone(this.option.dictQuery)
      WORKER.getTeamList({ ids: this.value, ...query }).then(res => {
        const temp = res.data.data
        this.staffData = temp
        this.workerListLoading = false
        this.staffLoaded = true
        setTimeout(() => {
          this.staffLoaded = false
        }, 500);
      })
    }
  },
  methods: {
    handleVisible() {
      this.visible = true
      this.onload()
    },
    onload() {
      this.staffData = []
      if (!this.disabled) {
        this.workerListLoading = true
        const query = deepClone(this.option.dictQuery)
        WORKER.getTeamList(query).then(res => {
          const temp = res.data.data
          this.staffData = temp.filter(el => {
            if (this.option.hasSupervisor) {
              return el.isSupervisor !== 1
            }
            return el
          })
          this.workerListLoading = false
        })
      }
    },
    handleStaffClick(e) {
      this.chcekedStaff = [e.id]
    },
    handleResStaffClick(e) {
      this.chcekedResStaff = [e.id]
    },
    handleModelConfirm() {
      this.visible = false
      this.checkedStaffData = this.chcekedStaffResult
      const res = this.chcekedStaffResult.map(o => o.id).join()

      const { recentlyStaff } = this
      this.chcekedStaffResult.forEach(item => {
        if (!recentlyStaff.find(o => o.id === item.id)) {
          recentlyStaff.push(item)
        }
      });
      const temp = this.recentlyUser
      temp.staff = recentlyStaff
      this.$store.commit('SET_RECENTLY_USER', temp)

      this.$emit('input', res)
    },
    delCheckedStaff(e, id) {
      e.preventDefault();
      const temp = []
      this.chcekedStaffResult.forEach(item => {
        if (item.id !== id) {
          temp.push(item)
        }
      })
      this.chcekedStaffResult = [...temp]
      const res = temp.map(o => o.id).join()
      this.$emit('input', res)
    },
    handleMoveRes() {
      const filter = this.staffData.filter(o => this.chcekedStaff.indexOf(o.id) !== -1)
      if (!this.multiple) {
        this.chcekedStaffResult = [...filter]
      } else {
        const temp = [...this.chcekedStaffResult]
        filter.forEach(item => {
          if (!temp.find(o => o.id === item.id)) {
            temp.push(item)
          }
        });
        this.chcekedStaffResult = temp
      }
      this.chcekedStaff = []
      this.hoverConfirm = true
      setTimeout(() => {
        this.hoverConfirm = false
      }, 500);
    },
    handleClearRes() {
      const temp = []
      this.chcekedStaffResult.forEach(item => {
        if (this.chcekedResStaff.indexOf(item.id) === -1) {
          temp.push(item)
        }
      });
      this.chcekedStaffResult = temp
      this.chcekedResStaff = []
      this.hoverConfirm = true
      setTimeout(() => {
        this.hoverConfirm = false
      }, 500);
    },
    close() {
      this.visible = false
      this.hoverConfirm = false
    },
    clearValue() {
      this.chcekedStaffResult = []
      this.chcekedResStaff = []
      this.$emit('input', '')
    },
    handleTeamDisabled(e) {
      return e.deptType !== 3
    },
    handleSearchWorker() {
      this.workerListLoading = true
      const query = deepClone(this.option.dictQuery)
      WORKER.getTeamList({ ...query, nameOrNo: this.searchWorker }).then(res => {
        const temp = res.data.data
        this.staffData = temp
        this.workerListLoading = false
        this.staffLoaded = true
      })
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.staff-StaffSelector{
    padding: 0 2px;
    width: 100%;
    box-sizing: border-box;
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    font-feature-settings: "tnum";
    position: relative;
    display: inline-block;
    outline: 0;
    &_content{
        display: block;
        cursor: pointer;
        padding: 0 15px 0 11px;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-top: 1.02px solid #d9d9d9;
        border-radius: 4px;
        outline: none;
        user-select: none;
        min-height: 2.714rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 2.714rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s;
        &:hover{
            box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
        }

        .placeholder, .hasValue{
            display: inline-block;
            position: relative;
            width: 100%;
            line-height: 20px;
            &-icon{
                position: absolute;
                color: #bfbfbf;
                right: 0;
                top: 50%;
                transform: translateY(calc(-50% + 2px));
                background-color: #FFF;
                z-index: 1;
            }
        }
        .placeholder{
            color: #bfbfbf;
        }
        .hasValue{
            color: rgba(0,0,0,.65);
            &-icon{
                color: #fff;
                transition: color .3s;
            }
        }
        &:hover{
            .hasValue{
                &-icon{
                    color: #bfbfbf;
                    transition: color .3s;
                    z-index: 2;
                    &:hover{
                        color: #797979;
                    }
                }
            }
        }
    }
}
.selector-content{
    height: 500px;
    .overlay-box{
        // height: 220px;
        height: 200px;
        width: calc(100% - 15px);
        overflow: auto;
        background-color: #FFF;
        padding:  5px 8px;
    }
    .tab-pane{
        width: 50%;
    }

    .staff-search{
        width: calc(50% - 15px);
        margin: 5px 0;
        display: flex;
        .btn{
          margin-left: 5px;
        }
    }

    .staff-list{
        margin-top: 10px;
        height: 200px;
        width: calc(50% - 15px);
        overflow: auto;
        background-color: #FFF;
        padding:  5px 4px;
        &__item{
            padding: 0 4px;
            margin: 2px 0;
            border-radius: 5px;
            &:hover, &-checked{
                background-color: #eee;
                cursor: pointer;
            }
            &-checked{
                color: #409EFF;
                background-color: #cae1fc !important;
            }
        }
        &__maxheight{
            height: 406px;
        }
    }
    .checked-staff{
        height: calc(100% - 71px);
        width: calc(50% - 28px);
        background-color: #FFF;
        padding:  5px 4px;
        position: absolute;
        left: calc(50% + 15px);
        top: 61px;
        &__btns{
            position: absolute;
            top: 50%;
            left: -25px;
            transform: translateY(-50%);
            width: 20px;
            &>div{
                width: 100%;
                border-radius: 5px;
                border: 1px solid #ddd;
                background-color: #FFF;
                padding: 5px 0;
                cursor: not-allowed;
            }
            &>div:first-child{
                margin-bottom: 10px;
            }
            .not-disabled{
                background-color: #409EFF;
                color: #FFF;
                cursor: pointer;
                &:hover{
                    background-color: #78aff9;
                }
            }
            .is-disabled{
                cursor: not-allowed;
            }
        }
        &__content{
            height: 100%;
            overflow: auto;
            padding:  5px 4px;
        }
        &::before{
            content: '';
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            border: 1px solid #ddd;
            border-radius: 5px;
            z-index: -1;
        }
    }
}
.my-border{
    border-radius: 5px;
    border: 1px solid #ddd;
    transition: border-color 0.15s ease-in-out, box-shadow 0.3s;
    &__hover{
        border: 1px solid #FFF !important;
        box-shadow: 0 0 0 4px rgb(24 144 255 / 30%);
    }
    &__hover-wrning{
        box-shadow: 0 0 0 4px rgb(230 162 61 / 30%);
    }
}
.mt-0-5{
  margin-top: 0.5rem;
}
.disabled-theme {
  color: rgb(192, 196, 204);
}

</style>
<style lang="scss">
.staff-selector-modal_body{
    background-color: #EEE;
    padding: 0.8rem 0.8rem !important;
    .custom-control.custom-checkbox{
      padding-left: 1.8rem;
    }
    .custom-control-label{
      cursor: pointer;
      width: 100%;
    }
}
</style>
